<template>
    <div class="modal_bg" v-if="show" @click="fnEvent(false)"></div>
    <div class="modal_layer" v-if="show">
        <div class="modal_title">
            {{ userInfo === null ? "계정 추가" : `정보수정` }}
            <div class="close_btn" @click="fnEvent(false)">
                <img src="@/assets/common/close.png" alt="" />
            </div>
        </div>
        <form action="">
            <div class="modal_content">
                <div class="user_modal">
                    <div>
                        <p>아이디</p>
                        <input type="text" placeholder="ID" v-model="user.id" :disabled="props.userInfo === null ? false : true" />
                    </div>
                    <div>
                        <p>새비밀번호</p>
                        <input
                            type="password"
                            placeholder="새비밀번호를 입력하세요"
                            v-model="user.newPw"
                            autoComplete="off"
                            @input="passwordCheck"
                        />
                    </div>
                    <div>
                        <p>새비밀번호 확인</p>
                        <input
                            type="password"
                            placeholder="새비밀번호를 입력하세요"
                            v-model="user.checkPw"
                            @input="passwordCheck"
                            autoComplete="off"
                        />
                    </div>
                    <div v-if="!state.checkPassword">
                        <p class="pwError">{{ state.pwError }}</p>
                    </div>
                    <div>
                        <p>이름</p>
                        <input type="text" placeholder="이름" v-model="user.name" />
                    </div>
                    <div>
                        <p>팀</p>
                        <select name="deptName" id="deptName" v-model="user.dept">
                            <option v-for="item in state.deptList" :value="item.idx">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                    <div>
                        <p>직책</p>
                        <select name="positionName" id="positionName" v-model="user.position">
                            <option v-for="item in state.positionList" :value="item.idx">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                    <div>
                        <p>업무내용</p>
                        <textarea placeholder="내용" v-model="user.workDetail"></textarea>
                    </div>
                    <div>
                        <p>X 계정</p>
                        <div class="twitter_input">
                            <input type="text" placeholder="X 아이디를 입력하세요" v-model="user.twitterId" autoComplete="off" />
                            <input type="password" placeholder="X 비밀번호를 입력하세요" v-model="user.twitterPw" autoComplete="off" />
                        </div>
                    </div>
                    <div class="user_approve" v-if="user.state === 9 || user.state === 1">
                        <p>승인여부</p>
                        <label class="chk">
                            <input type="checkbox" v-model="user.approved" :disabled="user.state === 1 ? true : false" />
                            <span></span>
                        </label>
                    </div>
                </div>
                <div class="modal_btn" @click="fnEvent(true)">
                    {{ btnTitle }}
                </div>
            </div>
        </form>
    </div>
</template>
<script lang="ts">
    import { apiService, globalStore, reactive, res, watch } from "@/BaseComponent";
    import { passwordPattern } from "@/services/checkForm";

    export default {
        props: {
            userInfo: {},
            yes: {
                type: String,
                default: "확인",
            },
            no: {
                type: String,
                default: "취소",
            },
            show: {
                type: Boolean,
                default: false,
            },
            btnTitle: {
                type: String,
                default: "수정하기",
            },
        },
        emits: ["close"],
        setup(props: any, { emit }: any) {
            const global = globalStore();
            const state = reactive({
                positionList: [] as Array<any>,
                deptList: [] as Array<any>,
                checkPassword: true,
                pwError: "" as string,
            });
            const user = reactive({
                idx: 0 as number,
                id: "" as string,
                newPw: "" as string,
                checkPw: "" as string,
                name: "" as string,
                dept: 1 as number,
                position: 1 as number,
                workDetail: "" as string,
                twitterId: "" as string,
                twitterPw: "" as string,
                state: 1 as number,
                approved: false as boolean,
            });

            const fnEvent = (result: boolean) => {
                if (result) {
                    if (!user.id) return alert("아이디는 필수 값입니다.");
                    if (!user.name) return alert("이름은 필수 값입니다.");
                    if (!user.dept) return alert("부서는 필수 값입니다.");
                    if (!user.position) return alert("직급은 필수 값입니다.");
                    if (!state.checkPassword) return alert("비밀번호를 확인해주세요");
                }
                emit("close", result, user);
                user.newPw = "";
                user.checkPw = "";
                state.checkPassword = true;
            };
            watch(
                () => props.show,
                () => {
                    if (props.show) {
                        document.body.style.overflow = "hidden";
                    } else {
                        document.body.style.overflow = "auto";
                    }
                },
            );

            watch(props, () => {
                if (props.show) {
                    if (props.userInfo) {
                        user.idx = props.userInfo.idx;
                        user.id = props.userInfo.id;
                        user.name = props.userInfo.name;
                        user.dept = props.userInfo.deptVO?.idx;
                        user.position = props.userInfo.positionVO?.idx;
                        user.workDetail = props.userInfo.workDetail;
                        user.twitterId = props.userInfo?.twitterId;
                        user.twitterPw = props.userInfo?.twitterPw;
                        user.state = props.userInfo.state;
                        user.approved = props.userInfo.state === 1 ? true : false;
                    } else {
                        user.idx = 0;
                        user.id = "";
                        user.name = "";
                        user.dept = 0;
                        user.position = 0;
                        user.workDetail = "";
                        user.twitterId = "";
                        user.twitterPw = "";
                        user.state = 0;
                    }
                    global.position ? (state.positionList = global.position) : getPositionList();
                    global.dept ? (state.deptList = global.dept) : getDeptList();
                }
            });

            const getPositionList = async () => {
                const res: res = await apiService.base.getPositionList();
                if (res.returnCode === 0) {
                    state.positionList = res.list;
                }
            };

            const getDeptList = async () => {
                const res: res = await apiService.base.getDeptList();
                if (res.returnCode === 0) {
                    state.deptList = res.list;
                }
            };

            const passwordCheck = () => {
                const res = passwordPattern(user.newPw, user.checkPw);
                if (res) {
                    state.checkPassword = res.code === 0 ? true : false;
                    state.pwError = res.content;
                }
            };
            return { props, fnEvent, state, user, passwordCheck };
        },
    };
</script>
<style scoped>
    .pwError {
        padding-left: 140px;
        font-size: 13px;
        color: red;
    }
    .twitter_input {
        display: flex;
        width: 83%;
        justify-content: flex-start;
        gap: 15px;
    }
    .twitter_input input {
        width: 49%;
        height: 44px;
        padding: 10px;
        border: 1px solid #dfdfdf;
    }
</style>
